import { AttachmentImageSize, EventLocationUseType, EventObserverActionUseType } from "../enums";

export interface IEventSettingSimple {
    attachmentImageSize: AttachmentImageSize;
    observerActionUseType: EventObserverActionUseType;
    locationUseType: EventLocationUseType;

    observerActionIsInUse(): boolean;
    observerActionIsRequired(): boolean;
    locationIsInUse(): boolean;
}

export class EventSettingSimple implements IEventSettingSimple {
    attachmentImageSize: AttachmentImageSize;
    observerActionUseType: EventObserverActionUseType;
    locationUseType: EventLocationUseType;

    constructor();
    constructor(obj: IEventSettingSimple);
    constructor(obj?: any) {
        this.attachmentImageSize = obj && obj.attachmentImageSize || AttachmentImageSize.Large;
        this.observerActionUseType = obj && obj.observerActionUseType || EventObserverActionUseType.NotInUse;
        this.locationUseType = obj && obj.locationUseType || EventLocationUseType.NotInUse;
    }

    observerActionIsInUse(): boolean {
        return this.observerActionUseType > EventObserverActionUseType.NotInUse;
    };

    observerActionIsRequired(): boolean {
        return this.observerActionUseType > EventObserverActionUseType.InUse;
    };

    locationIsInUse(): boolean {
        return this.locationUseType > EventLocationUseType.NotInUse;
    };
}